<template>
  <div>

                <CDataTable
                    :items="items"
                    :fields="fields"

                    :items-per-page="20"
                    hover
                    border
                    :pagination="pagination"
                    striped
                >
                  <template #row_id="{item,index}">

                    <td>
                      <p >{{ index+1 }}</p>

                    </td>

                  </template>

                  <template #amount="{item}">
                    <td>
                      <p >{{ item.amount }}</p>
                    </td>
                  </template>
                  <template #docDate="{item}">
                    <td>
                      <p >{{ get_date(item.docDate) }}</p>
                    </td>
                  </template>
                  <template #amountNegetive="{item}">
                    <td>
                      <p >{{ item.amountNegetive }}</p>
                    </td>
                  </template>
                  <template #accBalance="{item}">
                    <td>
                      <p >{{ item.accBalance }}</p>
                    </td>
                  </template>
                  <template #accBalanceNegetive="{item}">
                    <td>
                      <p >{{ item.accBalanceNegetive }}</p>
                    </td>
                  </template>

                  <template #kardexAccTypeTitle="{item}">
                    <td>
                      <strong >{{ item.kardexAccTypeTitle }}</strong>
                    </td>
                  </template>

                  <template #masterId="{item}">
                    <td>
                      <a href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                        {{ item.masterId }}
                        <CIcon name="cil-speedometer"/>
                      </a>

                    </td>

                  </template>

                  <template #summary="{item}">
                    <td>
                      <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                    </td>

                  </template>

                  <template #operation="{item}">
                    <td >
                      <CButton
                          class="m-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="goEditPerson(item)"
                      >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton class="m-1"
                               color="success"
                               variant="outline"
                               square
                               size="sm"
                               :title="$t('buttons.documents')"
                               @click="goToDocuments(item)"
                      >
                        <CIcon name="cil-list-rich"/>
                      </CButton>

                    </td>
                  </template>



                  <template #sumExistanceP="{item}">
                    <td>
                      <p v-if="item.sumExistance>0" >{{ item.sumExistance }}</p>
                      <p v-else >0</p>
                    </td>
                  </template>
                  <template #sumExistanceN="{item}">
                    <td>
                      <p v-if="item.sumExistance<=0" >{{ Math.abs(item.sumExistance) }}</p>
                      <p v-else >0</p>

                    </td>
                  </template>
                  <template #sumAmountP="{item}">
                    <td>
                      <p v-if="item.sumAmount>0" >{{ item.sumAmount }}</p>
                      <p v-else >0</p>

                    </td>
                  </template>

                  <template #sumAmountN="{item}">
                    <td>
                      <p v-if="item.sumAmount<=0" >{{ Math.abs(item.sumAmount) }}</p>
                      <p v-else >0</p>
                    </td>
                  </template>


                </CDataTable>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';



export default {
  name: 'Login',
  components: {

  },
  props:{
    items:Array,
    fields:Array,
    pagination:Boolean,
  },
  data() {
    return {



      status_form: 0
    }
  }, mounted() {


  }, watch: {

  },
  methods: {

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },

  }
}

</script>
